import CreateGiftingAddress from '@/services/logistics/addressService/CreateGiftingAddress';
import FetchAllUserAddresses from '@/services/logistics/addressService/FetchAllUserAddresses';
import UpdateSubscriptionAddress from '@/services/logistics/addressService/UpdateSubscriptionAddress';
import FetchAllUserGiftingAddresses from '@/services/logistics/addressService/FetchAllUserGiftingAddresses';
import DeleteAddresses from '@/services/logistics/addressService/DeleteAddresses';
import DeleteGiftingAddresses from '@/services/logistics/addressService/DeleteGiftingAddresses';

export default class AddressService {
    /**
     * Handle creating a new gifting address for the user's gifting address book.
     *
     * @param {*} payload
     *
     * @returns {Promise}
     */
    createGiftingAddress(payload) {
        return (new CreateGiftingAddress()).handle(payload);
    }

    /**
     * Get all the user's addresses.
     *
     * @param {number} userId
     *
     * @returns {Promise}
     */
    fetchAllUserAddresses(userId) {
        return (new FetchAllUserAddresses()).handle(userId);
    }

    /**
     * Handle fetching the user's gifting address book.
     *
     * @param {number} userId
     *
     * @returns {Promise}
     */
    fetchAllUserGiftingAddresses(userId) {
        return (new FetchAllUserGiftingAddresses()).handle(userId);
    }

    /**
     * Handle updating the given subscription address via the API.
     *
     * @param {Number} subscriptionId
     * @param {Number} addressId
     * @param {*} payload
     *
     * @returns Promise
     */
    updateSubscriptionAddress(subscriptionId, addressId, payload) {
        return (new UpdateSubscriptionAddress()).handle(subscriptionId, addressId, payload);
    }

    deleteAddress(userId, addressId) {
        return (new DeleteAddresses()).handle(userId, addressId);
    }

    deleteGiftingAddress(userId, addressId) {
        return (new DeleteGiftingAddresses()).handle(userId, addressId);
    }
}
